<ion-buttons id="aaa-menu">
  <ion-menu-button color="drr-dark" auto-hide="false" menu="aaa-drr-menu" />
</ion-buttons>
